import { render, staticRenderFns } from "./opt-allegati.vue?vue&type=template&id=69d799a9&"
import script from "./opt-allegati.vue.ts?vue&type=script&lang=ts&"
export * from "./opt-allegati.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports